import { ISetOverviewIdTypeAction } from "action/interfaces/utils.interface";

export function setOverviewId(overviewId: string): ISetOverviewIdTypeAction {
  return {
    type: "OVERVIEW_ID",
    data: overviewId,
  };
}
